module.exports = __webpack_public_path__ + "img/avatar.8fae018b.png";